import { Splitter, SplitterPanel } from "primereact/splitter";

import { TopPanel } from "sj-ui-toolkit/src/atlas/components/PanelWithDrawers";
import { C, themeClasses as T } from "sj-ui-toolkit/src/atlas/utils/themeClasses";
import { SandboxLessonDetails } from "sj-ui-toolkit/src/client";

import { SandboxProvider } from "../SandboxLesson/contexts/SandboxProvider";
import LeftPanel from "../SandboxLesson/LeftPanel/LeftPanel";
import AppLabControls from "./AppLabControls";

import S from "../_Lesson.module.scss";
import { TabsProvider } from "../SandboxLesson/contexts/Tabs";

interface AppLabLessonProps {
  lessonDetails: SandboxLessonDetails;
  tournamentUuid?: string;
  onLessonFinish: () => void;
  onSandboxReady?: () => void;
  isAppLabLite?: boolean;
}

const AppLabLesson = ({
  lessonDetails,
  tournamentUuid,
  onLessonFinish,
  onSandboxReady,
  isAppLabLite = false,
}: AppLabLessonProps) => {
  return (
    <SandboxProvider
      lessonDetails={lessonDetails}
      onLessonFinish={onLessonFinish}
      tournamentUuid={tournamentUuid}
      onSandboxReady={onSandboxReady}
    >
      {isAppLabLite ? (
        <TopPanel className="h-full bg-elevation-1 rounded-sm p-3">
          <h1 className="sr-only">{lessonDetails.title}</h1>
          <TabsProvider>
            <AppLabControls tabs={lessonDetails.sandbox?.tabs} showRunTests={false} />
          </TabsProvider>
        </TopPanel>
      ) : (
        <Splitter
          className={C(T.splitterGap, "h-full")}
          aria-label="Resize lesson panels"
          data-testid="app-lab-lesson"
        >
          <SplitterPanel size={30} minSize={20} className={C("flex flex-col h-full", S.leftPanel)}>
            <LeftPanel lessonDetails={lessonDetails} />
          </SplitterPanel>
          <SplitterPanel size={70} minSize={40} className="max-h-full">
            <TopPanel className="bg-elevation-1 rounded-l-sm p-3">
              <TabsProvider>
                <AppLabControls tabs={lessonDetails.sandbox?.tabs} />
              </TabsProvider>
            </TopPanel>
          </SplitterPanel>
        </Splitter>
      )}
    </SandboxProvider>
  );
};

export default AppLabLesson;
